import React, {useEffect} from "react";
import {withWorkbench} from "../../layout/Workbench";
import PieChart from "../../lib/appfuse-react/chart/PieChart";
import {useDispatch, useSelector} from "../../store";
import {selectDashBoard, setDashBoard} from "../../reducer/util/utilReducer";
import ajax from "../../lib/appfuse-react/core/ajax";
import lang from "../../lib/appfuse-react/core/lang";
import Box from "../../lib/appfuse-react/component/Box";
import DataTable, {DataColumn} from "../../lib/appfuse-react/component/DataTable";
import BarChart from "../../lib/appfuse-react/chart/BarChart";
import numeral from "../../lib/appfuse-react/core/numeral";
import Paper from "../../lib/appfuse-react/component/Paper";
import {Typography} from "@material-ui/core";
import i18n from "../../lib/appfuse-react/core/i18n";

function Main(props) {
    const data = useSelector(selectDashBoard);
    const dispatch = useDispatch();
    const {customerData, customerDataWithTotal, productData, productDataWithTotal, levels} = data;

    useEffect(() => {
        (async () => {
            const response = await ajax.get('customers/dashboardData');
            dispatch(setDashBoard(response.data));
        })()
    }, []);

    return (
        <Box fullWidth fullHeight overflow='hidden' >
            {
                lang.isNotEmpty(data) &&
                <Box fullWidth fullHeight display='flex' overflow='hidden' justifyContent='space-evenly' alignItems={'center'}>
                    <Box width={'48%'} fullHeight display='flex' flexDirection={'column'} justifyContent={'space-evenly'} alignItems={'center'}>
                        <Paper height={'45%'} fullWidth display='flex' flexDirection={'column'} overflow={'hidden'} alignItems={'center'} backgroundOpacity={0.97} backgroundColor="white" paddingY={1}>
                            <Typography variant={'h4'}>{i18n.translate('Customer')}</Typography>
                            <Box fullHeight fullWidth display={'flex'} overflow={'hidden'}>
                                <Box fullHeight width={'60%'}>
                                    <PieChart data={customerData} margin={{ top: 20, right: 120, bottom: 20, left: 120 }}/>
                                </Box>
                                <Box fullHeight width={'37%'} overflow={'auto'} display={'flex'} alignItems={'center'}>
                                    <DataTable data={customerDataWithTotal} dense maxHeight={'100%'} stickyHeader>
                                        <DataColumn accessor='id'/>
                                        <DataColumn accessor='value' formatter={numeral} pattern={'0,0'}/>
                                        <DataColumn accessor='percent' align={'right'}/>
                                    </DataTable>
                                </Box>
                            </Box>
                        </Paper>
                        <Paper height={'45%'} fullWidth display='flex' flexDirection={'column'} overflow={'hidden'} alignItems={'center'} backgroundOpacity={0.97} backgroundColor="white" paddingY={1}>
                            <Typography variant={'h4'}>{i18n.translate('Product')}</Typography>
                            <Box fullHeight fullWidth display={'flex'} overflow={'hidden'}>
                                <Box fullHeight width={'60%'}>
                                    <PieChart data={productData} margin={{ top: 20, right: 120, bottom: 20, left: 120 }}/>
                                </Box>
                                <Box fullHeight width={'37%'} overflow={'auto'}  display={'flex'} alignItems={'center'}>
                                    <DataTable data={productDataWithTotal} dense maxHeight={'100%'} stickyHeader>
                                        <DataColumn accessor='id'/>
                                        <DataColumn accessor='value' formatter={numeral} pattern={'0,0'}/>
                                        <DataColumn accessor='percent' align={'right'}/>
                                    </DataTable>
                                </Box>
                            </Box>
                        </Paper>
                    </Box>
                    <Paper width={'48%'} height={'93.3%'} display='flex' flexDirection={'column'} justifyContent={'space-evenly'} alignItems={'center'} backgroundOpacity={0.97} backgroundColor="white" paddingY={1}>
                        <Typography variant={'h4'}>{i18n.translate('Assessment Level')}</Typography>
                        <Box height={'55%'} fullWidth>
                            <BarChart data={productData} valueBy={levels} groupMode="grouped" enableLegend
                                      margin={{ top: 10, right: 150, bottom: 65, left: 75 }}
                                      axisBottom={{legend: "通路"}}
                                      axisLeft={{legend: "產品數"}}/>
                        </Box>
                        <Box height={'40%'} width={'90%'}>
                            <DataTable data={productDataWithTotal} dense maxHeight={'100%'} stickyHeader>
                                <DataColumn accessor='id' label={'通路'}/>
                                {
                                    levels.map(level => {
                                        return <DataColumn accessor={level} label={level} formatter={numeral} pattern={'0,0'}/>
                                    })
                                }
                                <DataColumn accessor='value' label={'合計'} formatter={numeral} pattern={'0,0'}/>
                                <DataColumn accessor='percent' label={'Percent'} align={'right'}/>
                            </DataTable>
                        </Box>
                    </Paper>
                </Box>
            }
        </Box>
    );
}

export default withWorkbench(Main);